<template>
  <section>
    <div id="tabs">
      <div :class="isProfitTabActive" @click="gameProfitView">
        <div>CLUB EARNINGS</div>
      </div>
      <div :class="isSalaryTabActive" @click="PlayerSalaryView">
        <div>PLAYER SALARIES</div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  methods: {
    gameProfitView() {
      this.$store.commit("setView", { value: true });
    },
    PlayerSalaryView() {
      this.$store.commit("setView", { value: false });
       this.scrollToView();
    },
  },
  computed: {
    isProfitTabActive() {
      if (this.$store.getters.isProfitViewActive) {
        return "tab-active";
      } else {
          return "tab";
      }
    },
    isSalaryTabActive() {
      if (!this.$store.getters.isProfitViewActive) {
        return "tab-active";
      } else {
          return "tab";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
// section {
//   margin: 40px 0px 0px 0px;
// }

#tabs {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  font-family: Play;
  font-weight: bold;
  font-size: 14px;
  text-align: center;
}

.tab {
  margin: 0px 20px 0px 20px;
  border-radius: 30px;
  padding: 10px 40px 10px 40px;
  color: $white;
  border: 2px $highlight1 solid;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  &:hover {
    cursor: pointer;
    border: 2px $white solid;
  }
}

.tab-active {
  @extend .tab;
  background: linear-gradient($highlight1, $highlight2);
  color: $grey;
  border: none;
  padding: 12px 42px 12px 42px;
  &:hover {
    cursor: pointer;
    border: none;
  }
}
</style>